/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable react/forbid-prop-types */

import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  MdBlockFlipped,
  MdKeyboardArrowRight,
  MdOutlineArrowRightAlt,
} from 'react-icons/md';
import { Card, Col, Row } from 'react-bootstrap';
import {
  formatCurrency,
  formatDate,
  formatTimeString,
  getNewDate,
  isMobileWidth,
} from '../../../shared/helper-utils/appUtils';
import {
  DATE_MONTH_YEAR_VIEW_FORMAT,
  NAVIGATION_ROUTES,
  ONLY_DATE_MONTH_FORMAT,
} from '../../../shared/constants/Constants';
import AppLink from '../../../shared/components/app-link/AppLink';
import {
  TicketsIcon,
  // VoucherIcon,
} from '../../../shared/components/app-icons/AppIcons';
import AppIconButton from '../../../shared/components/app-icon-button/AppIconButton';
import AppSidebar from '../../../shared/components/app-sidebar/AppSidebar';

const iconStyle = { fontSize: 22, marginRight: 8, color: '#374471' };

function BusBookingsListCard({ bookingData }) {
  const [showDetails, setShowDetails] = useState(false);
  // const viewDetails = () => {
  //   let route = NAVIGATION_ROUTES.BUS.BOOKING_DETAILS;
  //   route = route.replace(':transactionId', bookingData.Txid);
  //   navigate(route);
  // };
  const getBusTicketRoute = (txid) => {
    let route = NAVIGATION_ROUTES.BUS.PRINT_TICKETS;
    route = route.replace(':transactionId', txid);
    return route;
  };
  const getBusInvoiceRoute = (txid) => {
    let route = NAVIGATION_ROUTES.BUS.BUS_INVOICE;
    route = route.replace(':transactionId', txid);
    return route;
  };
  const getBusBookingCancelRoute = (txid) => {
    let route = NAVIGATION_ROUTES.BUS.BOOKING_CANCEL;
    route = route.replace(':transactionId', txid);
    return route;
  };

  const getFullName = () => {
    let name = '';
    if (bookingData.PaxSalutation) name += bookingData.PaxSalutation;
    if (bookingData.PaxFirstName) name += ` ${bookingData.PaxFirstName}`;
    if (bookingData.PaxLastName) name += ` ${bookingData.PaxLastName}`;
    return name;
  };

  return (
    <div>
      {isMobileWidth() ? (
        <>
          <div
            className="d-flex justify-content-between border-bottom-2 flight-list-card"
            onClick={() => setShowDetails(true)}
          >
            <div className="d-flex gap-4 align-items-center">
              <div className="d-flex flex-column">
                <div className="d-flex align-items-center gap-1">
                  <div className="d-flex gap-1 align-items-center">
                    <span className="fs-18 fw-600">
                      {bookingData.SourceName.split('(')[0]}
                    </span>
                    <span className="fs-4 secondary-color">
                      <MdOutlineArrowRightAlt />
                    </span>
                    <span className="fs-18 fw-600">
                      {bookingData.DestinationName.split('(')[0]}
                    </span>
                  </div>
                </div>
                <div className="grey-color flight-list-card_tx-details_trip-type pt-1">
                  <span className=" fw-500 fs-12">
                    Ticket No - {bookingData.SupplierTicketNumber}
                  </span>
                  <div className=" fw-500 fs-12">
                    <span>
                      {formatDate(
                        getNewDate(bookingData.DateOfJourney),
                        DATE_MONTH_YEAR_VIEW_FORMAT,
                      )}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div className="d-flex justify-content-center">
              <AppIconButton variant="transparent">
                <MdKeyboardArrowRight className="fs-1 primary-color" />
              </AppIconButton>
            </div>
          </div>
          {showDetails && (
            <AppSidebar
              sidebarTitle="Bus Booking Details"
              onHideSidebar={() => setShowDetails(false)}
              animatedClass="slide-from-right-animation"
              className="app-mobile-datepicker-modal"
            >
              <div className="booking-review-page__body">
                <div className="bus-booking-review-page__body_bus-details">
                  <div className="d-flex justify-content-between mb-3">
                    <div className="d-flex flex-column">
                      <span className="fs-18 fw-600">
                        {bookingData.TravelsName}
                      </span>
                      <span className="fs-12 grey-color">
                        {bookingData.BusType}
                      </span>
                    </div>
                    <div className="d-flex flex-column">
                      <span className="fs-12 grey-color">
                        Seat No: {bookingData.SeatsSelected}
                      </span>
                    </div>
                  </div>
                  <div className="d-flex justify-content-between align-items-center">
                    <div>
                      <div className="fs-18">
                        <span className="fw-600">
                          {bookingData.DepTime
                            ? formatTimeString(bookingData.DepTime)
                            : ''}
                        </span>
                        ,{' '}
                        <span className="grey-color">
                          {bookingData.DateOfJourney
                            ? formatDate(
                                getNewDate(bookingData.DateOfJourney),
                                ONLY_DATE_MONTH_FORMAT,
                              )
                            : ''}
                        </span>
                      </div>
                      <div className="fs-14 grey-color">
                        {bookingData.SourceName}
                        <div>{bookingData.BoardingPointName}</div>
                      </div>
                    </div>
                    <div className="text-end">
                      <div className="fs-18">
                        <span className="fw-600">
                          {bookingData.ArrTime
                            ? formatTimeString(bookingData.ArrTime)
                            : ''}
                        </span>
                        ,{' '}
                        <span className="grey-color">
                          {bookingData.ArrivalDate
                            ? formatDate(
                                getNewDate(bookingData.ArrivalDate),
                                ONLY_DATE_MONTH_FORMAT,
                              )
                            : ''}
                        </span>
                      </div>
                      <div className="fs-14 grey-color">
                        {bookingData.DestinationName}
                        <div>{bookingData.DroppingPointName}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="d-flex justify-content-between px-3 text-capitalize">
                <div className="fs-12 primary-color">Total Amount</div>
                <div className="fs-14 fw-500">
                  {formatCurrency(bookingData.InvoiceTotal)}
                </div>
              </div>
              <div className="p-2">
                <div className="d-flex justify-content-between bg-body-secondary p-2">
                  <div className="fs-12 primary-color">Traveller</div>
                  <div className="fs-12 primary-color">Mobile No</div>
                </div>

                <div className="d-flex justify-content-between p-2 text-capitalize">
                  <div className="fs-14 fw-500">
                    {bookingData.PaxFirstName} {bookingData.PaxLastName}
                  </div>
                  <div className="fs-14 fw-500">{bookingData.PaxMobile}</div>
                </div>
              </div>
            </AppSidebar>
          )}
        </>
      ) : (
        <Card className="booking-list-card">
          <Row>
            <Col lg={12} md={12} sm={12} xs={12}>
              <Card.Body className="booking-list-card__body">
                <Row className="spacing-16">
                  <Col
                    className="d-flex flex-column"
                    lg={2}
                    md={2}
                    sm={2}
                    xs={6}
                  >
                    <span className="booking-list-card__body_header">
                      Tx.ID
                    </span>
                    <span className="booking-list-card__body_value">
                      {bookingData.Txid}
                    </span>
                  </Col>
                  <Col
                    className="d-flex flex-column hide-xs"
                    lg={2}
                    md={2}
                    sm={2}
                    xs={6}
                  >
                    <span className="booking-list-card__body_header">
                      Transaction date
                    </span>
                    <span className="booking-list-card__body_value text-uppercase">
                      {bookingData.TxDate}
                    </span>
                  </Col>
                  <Col
                    className="d-flex flex-column hide-xs"
                    lg={2}
                    md={2}
                    sm={2}
                    xs={6}
                  >
                    <span className="booking-list-card__body_header">
                      Invoice Amount
                    </span>
                    <span className="booking-list-card__body_value text-uppercase">
                      {bookingData.InvoiceTotal}
                    </span>
                  </Col>
                  <Col
                    className="d-flex flex-column hide-xs"
                    lg={2}
                    md={2}
                    sm={2}
                    xs={6}
                  >
                    <span className="booking-list-card__body_header">
                      Commission
                    </span>
                    <span className="booking-list-card__body_value text-uppercase">
                      {bookingData.Commission}
                    </span>
                  </Col>
                  <Col
                    className="d-flex flex-column"
                    lg={2}
                    md={2}
                    sm={2}
                    xs={6}
                  >
                    <span className="booking-list-card__body_header">
                      Pax Name
                    </span>
                    <span className="booking-list-card__body_value">
                      {getFullName()}
                    </span>
                  </Col>
                  <Col
                    className="d-flex flex-column hide-xs"
                    lg={2}
                    md={2}
                    sm={2}
                    xs={6}
                  >
                    <span className="booking-list-card__body_header">
                      Travels
                    </span>
                    <span className="booking-list-card__body_value text-uppercase">
                      {bookingData.TravelsName}
                    </span>
                  </Col>
                  <Col
                    className="d-flex flex-column"
                    lg={2}
                    md={2}
                    sm={2}
                    xs={6}
                  >
                    <span className="booking-list-card__body_header">
                      Origin
                    </span>
                    <span className="booking-list-card__body_value text-uppercase">
                      {bookingData.SourceName}
                    </span>
                  </Col>
                  <Col
                    className="d-flex flex-column"
                    lg={2}
                    md={2}
                    sm={2}
                    xs={6}
                  >
                    <span className="booking-list-card__body_header">
                      Destination
                    </span>
                    <span className="booking-list-card__body_value text-uppercase">
                      {bookingData.DestinationName}
                    </span>
                  </Col>
                  <Col
                    className="d-flex flex-column"
                    lg={2}
                    md={2}
                    sm={2}
                    xs={6}
                  >
                    <span className="booking-list-card__body_header">
                      Ticket Number
                    </span>
                    <span className="booking-list-card__body_value text-uppercase">
                      {bookingData.SupplierTicketNumber}
                    </span>
                  </Col>
                  <Col
                    className="d-flex flex-column hide-xs"
                    lg={2}
                    md={2}
                    sm={2}
                    xs={6}
                  >
                    <span className="booking-list-card__body_header">
                      Booking Status
                    </span>
                    <span className="booking-list-card__body_value text-uppercase">
                      {bookingData.TicketStatus}
                    </span>
                  </Col>
                  <Col
                    className="d-flex flex-column"
                    lg={2}
                    md={2}
                    sm={2}
                    xs={6}
                  >
                    <span className="booking-list-card__body_header">
                      Journey Date
                    </span>
                    <span className="booking-list-card__body_value">
                      {bookingData.DateOfJourney
                        ? formatDate(
                            getNewDate(bookingData.DateOfJourney),
                            DATE_MONTH_YEAR_VIEW_FORMAT,
                          )
                        : ''}
                    </span>
                  </Col>
                  <Col
                    className="d-flex flex-column hide-xs"
                    lg={2}
                    md={2}
                    sm={2}
                    xs={6}
                  >
                    <span className="booking-list-card__body_header">
                      Pax Contact
                    </span>
                    <span className="booking-list-card__body_value text-uppercase">
                      {bookingData.PaxMobile}
                    </span>
                  </Col>
                </Row>
              </Card.Body>
            </Col>
            <Col lg={12} md={12} sm={12} xs={12}>
              <div className="booking-list-card__actions">
                <Row className="spacing-0">
                  {/* <Col className="border-767px-bottom" lg={4} md={4} sm={4} xs={12}>
                <VoucherIcon style={iconStyle} />
                <AppLink
                  linkText="View Details"
                  // linkText="View Ticket"
                  onClick={viewDetails}
                  variant="grey"
                />
              </Col> */}
                  <Col
                    className="border-767px-bottom"
                    lg={4}
                    md={4}
                    sm={4}
                    xs={4}
                  >
                    <TicketsIcon style={iconStyle} />
                    <AppLink
                      isLink
                      linkText="View Ticket"
                      href={getBusTicketRoute(bookingData.Txid)}
                      variant="grey"
                      target="_blank"
                    />
                  </Col>
                  <Col
                    className="border-767px-bottom"
                    lg={4}
                    md={4}
                    sm={4}
                    xs={4}
                  >
                    <TicketsIcon style={iconStyle} />
                    <AppLink
                      isLink
                      linkText="View Invoice"
                      href={getBusInvoiceRoute(bookingData.Txid)}
                      variant="grey"
                      target="_blank"
                    />
                  </Col>
                  <Col className="border-end-0" lg={4} md={4} sm={4} xs={4}>
                    <MdBlockFlipped style={iconStyle} />
                    <AppLink
                      isLink
                      linkText="Cancel"
                      href={getBusBookingCancelRoute(bookingData.Txid)}
                      variant="grey"
                      target="_black"
                    />
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
        </Card>
      )}
    </div>
  );
}

BusBookingsListCard.propTypes = {
  bookingData: PropTypes.object.isRequired,
};

export default BusBookingsListCard;
